import Glide from "@glidejs/glide";
import Heading from "components/Heading/Heading";
import full11Img from "images/products/full1-1.png";
import full12Img from "images/products/full1-2.png";
import full13Img from "images/products/full1-3.png";
import full1Img from "images/products/full1.png";
import full21Img from "images/products/full2-1.png";
import full22Img from "images/products/full2-2.png";
import full23Img from "images/products/full2-3.png";
import full2Img from "images/products/full2.png";
import full31Img from "images/products/full3-1.png";
import full32Img from "images/products/full3-2.png";
import full33Img from "images/products/full3-3.png";
import full3Img from "images/products/full3.png";
import { FC,useEffect,useId } from "react";
import { Link } from "react-router-dom";
import CollectionCard from "./CollectionCard";

const DEMO_LARGE_PRODUCTS = [
  { images: [full1Img, full11Img, full12Img, full13Img], name: "Suede Bomber Jacket", desc: "Orange", price: 52 },
  { images: [full2Img, full21Img, full22Img, full23Img], name: "Downtown Pet Tote", desc: "Black and Orange", price: 88 },
  { images: [full3Img, full31Img, full32Img, full33Img], name: "Cader Leather Sneakers", desc: "3 Sizes Available", price: 60 },
];

export interface SectionSliderLargeProductProps {
  className?: string;
  itemClassName?: string;
}

const SectionSliderLargeProduct: FC<SectionSliderLargeProductProps> = ({
  className = "",
}) => {
  const id = useId();
  const UNIQUE_CLASS = "glidejs" + id.replace(/:/g, "_");

  useEffect(() => {
    // @ts-ignore
    const OPTIONS: Glide.Options = {
      perView: 3,
      gap: 32,
      bound: true,
      breakpoints: {
        1280: {
          gap: 28,
          perView: 2.5,
        },
        1024: {
          gap: 20,
          perView: 2.15,
        },
        768: {
          gap: 20,
          perView: 1.5,
        },

        500: {
          gap: 20,
          perView: 1,
        },
      },
    };

    let slider = new Glide(`.${UNIQUE_CLASS}`, OPTIONS);
    slider.mount();
    return () => {
      slider.destroy();
    };
  }, [UNIQUE_CLASS]);

  return (
    <div className={`nc-SectionSliderLargeProduct ${className}`}>
      <div className={`${UNIQUE_CLASS} flow-root`}>
        <Heading isCenter={false} hasNextPrev>
          Chosen by our experts
        </Heading>
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides">
            {DEMO_LARGE_PRODUCTS.map((product, index) => (
              <li className={`glide__slide`} key={index}>
                <CollectionCard
                  name={product.name}
                  price={product.price}
                  imgs={product.images}
                  description={product.desc}
                />
              </li>
            ))}

            <li className={`glide__slide   `}>
              <Link to={"/page-search"} className="block relative group">
                <div className="relative rounded-2xl overflow-hidden h-[410px]">
                  <div className="h-[410px] bg-black/5 dark:bg-neutral-800"></div>
                  <div className="absolute inset-y-6 inset-x-10  flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center relative">
                      <span className="text-xl font-semibold">More items</span>
                      <svg
                        className="absolute left-full w-5 h-5 ml-2 rotate-45 group-hover:scale-110 transition-transform"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.0701 9.57L12.0001 3.5L5.93005 9.57"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 20.4999V3.66992"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span className="text-sm mt-1">Show me more</span>
                  </div>
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SectionSliderLargeProduct;
